const moment = require('moment');

function formatMoney(n, c, d, t) {
    c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t;
    let s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

module.exports = {
    data() {
        return {
            formError: null,
            lang: window.lang,
            messageText: null,
            messageStatus: null,
        }
    },

    methods: {
        route(name, params, absolute) {
            return route(name, params, absolute);
        },

        localeRoute(name, params, absolute) {
            let locale = document.documentElement.lang;
            params['locales'] = locale;
            return route(name, params, absolute);
        },

        scrollToTop() {
            window.scrollTo(0,0);
        },

        formatDate(value, dateFormat, type) {
            if (!value) {
                return null;
            }

            let format = (dateFormat) ? dateFormat : 'DD/MM/YYYY HH:mm';

            if (type === 'time_if_not_zero') {
                if (moment(String(value)).format('HH:mm') === '00:00') {
                    format = dateFormat;
                } else {
                    format = dateFormat + ' HH:mm';
                }
            }

            return moment(String(value)).format(format);
        },
    },

    filters: {

        formatDate(value, dateFormat, type) {
            if (!value) {
                return null;
            }

            let format = (dateFormat) ? dateFormat : 'DD/MM/YYYY HH:mm';

            if (type === 'time_if_not_zero') {
                if (moment(String(value)).format('HH:mm') === '00:00') {
                    format = dateFormat;
                } else {
                    format = dateFormat + ' HH:mm';
                }
            }

            return moment(String(value)).format(format);
        },

        filterZero(value, defaultValue) {

            if (defaultValue) {
                defaultValue = null;
            }
            return value ? value : defaultValue;
        },

        upperCase(string) {
            return string ? string.toUpperCase() : string;
        },

        floatVal(value, precision){

            if(typeof precision === 'undefined' || isNaN(precision) || !precision){
                precision = 2;
            }
            return formatMoney(value, precision, ',', '.');
        },

        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },

    computed: {
        formValidationErrors: function () {
            return this.formError ? this.formError.errors : []
        },
    }
};



// WEBPACK FOOTER //
// ./resources/js/components/VueMixin.js